// material-ui
import React from 'react';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';
import useDesignTokens from '../../themes/useDesignTokens';

// ==============================|| Loader ||============================== //

export default function Loader() {
  const tokens = useDesignTokens();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2001,
      }}
    >
      <CircularProgress
        data-testid="loader"
        sx={{ color: tokens.colors.border.highlightSolid }}
      />
    </Box>
  );
}
